import React, { useState, useEffect, useCallback } from 'react';
import axios from 'axios';
import { Briefcase, FileText, Mail } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const AdminDashboard = () => {
  const [stats, setStats] = useState({
    projects: 0,
    blogs: 0,
    contacts: 0
  });

  const fetchStats = useCallback(async () => {
    try {
      const [projectsRes, blogsRes, contactsRes] = await Promise.all([
        axios.get(`${API_URL}/api/projects`),
        axios.get(`${API_URL}/api/blogs`),
        axios.get(`${API_URL}/api/contacts`, { withCredentials: true })
      ]);
      
      setStats({
        projects: projectsRes.data.length,
        blogs: blogsRes.data.length,
        contacts: contactsRes.data.length
      });
    } catch (error) {
      console.error('Dashboard stats fetch failed:', error);
    }
  }, []);

  useEffect(() => {
    fetchStats();
  }, [fetchStats]);

  const statCards = [
    { id: 'projects', icon: <Briefcase size={32} className="text-accent" />, label: 'Total Projects', value: stats.projects, color: 'bg-teal-50' },
    { id: 'blogs', icon: <FileText size={32} className="text-accent" />, label: 'Total Blogs', value: stats.blogs, color: 'bg-cyan-50' },
    { id: 'contacts', icon: <Mail size={32} className="text-accent" />, label: 'Total Contacts', value: stats.contacts, color: 'bg-sky-50' },
  ];

  return (
    <div data-testid="admin-dashboard-page">
      <div className="mb-8">
        <h1 className="text-3xl font-bold text-primary mb-2" data-testid="dashboard-title">Dashboard</h1>
        <p className="text-text_muted">Welcome to your admin panel</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        {statCards.map((card) => (
          <div
            key={card.id}
            className={`${card.color} p-6 rounded-sm border border-border`}
            data-testid={`stat-card-${card.id}`}
          >
            <div className="flex items-center justify-between">
              <div>
                <p className="text-text_muted text-sm font-medium mb-1">{card.label}</p>
                <p className="text-3xl font-bold text-primary" data-testid={`stat-value-${card.id}`}>{card.value}</p>
              </div>
              <div>{card.icon}</div>
            </div>
          </div>
        ))}
      </div>

      <div className="bg-white p-6 rounded-sm border border-border">
        <h2 className="text-xl font-semibold text-primary mb-4">Quick Actions</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <a
            href="/admin/projects"
            className="px-6 py-4 bg-accent/10 text-accent rounded font-medium hover:bg-accent/20 transition-colors text-center"
            data-testid="quick-action-projects"
          >
            Manage Projects
          </a>
          <a
            href="/admin/blogs"
            className="px-6 py-4 bg-accent/10 text-accent rounded font-medium hover:bg-accent/20 transition-colors text-center"
            data-testid="quick-action-blogs"
          >
            Manage Blogs
          </a>
          <a
            href="/admin/contacts"
            className="px-6 py-4 bg-accent/10 text-accent rounded font-medium hover:bg-accent/20 transition-colors text-center"
            data-testid="quick-action-contacts"
          >
            View Contacts
          </a>
        </div>
      </div>
    </div>
  );
};

export default AdminDashboard;
